import { Box } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

import React from 'react';

// Crescent spinner (same as the platform's lucide Loader2), in the theme primary color
const useStyles = makeStyles(theme => ({
  spinner: {
    width: 40,
    height: 40,
    color: theme.palette.primary.main,
    animation: '$spin 0.8s linear infinite',
  },
  '@keyframes spin': {
    to: {
      transform: 'rotate(360deg)',
    },
  },
}));

export const CrescentSpinner = ({ size = 40, className = '' }: { size?: number; className?: string }) => {
  const classes = useStyles();
  return (
    <svg
      className={`${classes.spinner} ${className}`}
      style={{ width: size, height: size }}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={2.5}
      strokeLinecap="round"
      role="status"
      aria-label="Loading"
    >
      <path d="M21 12a9 9 0 1 1-6.219-8.56" />
    </svg>
  );
};

export const VerticalBarLoader = ({
  position = "fixed"
}) => {
  return (
    <Box
      position={position}
      width="100%"
      height="100%"
      top="0"
      left="0"
      display="flex"
      flexDirection="column"
      justifyContent="center"
      zIndex="99999"
      style={{ backgroundColor: 'rgb(255 255 255 / 20%)' }}
    >
      <Box display="flex" justifyContent="center">
        <CrescentSpinner />
      </Box>
    </Box>
  );
};
